
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M43.658 38.888h-35.3a5.129 5.129 0 01-5.128-5.119V11.118A5.126 5.126 0 018.352 6h35.3a5.144 5.144 0 015.137 5.118v22.651a5.129 5.129 0 01-5.131 5.119zM8.352 11.118v22.651h35.3V11.118zM49.44 46.876H2.56a2.559 2.559 0 110-5.118h46.88a2.559 2.559 0 110 5.118z"}})])])
          )
        }
      }
    